import { render } from "./ListaPermessi.vue?vue&type=template&id=9b10e3c8&ts=true"
import script from "./ListaPermessi.vue?vue&type=script&lang=ts"
export * from "./ListaPermessi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__